import * as React from "react";
import { SVGProps } from "react";

const ResultsSVG: React.FC<SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 1.5H6.05A1.5 1.5 0 0 0 4.55 3v2.51h.95a.75.75 0 0 1 0 1.5h-.95v3.718h.95a.75.75 0 0 1 0 1.5h-.95v3.718h.95a.75.75 0 0 1 0 1.5h-.95V21a1.5 1.5 0 0 0 1.5 1.5H20a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 20 1.5ZM3.05 17.446V21a3 3 0 0 0 3 3H20a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H6.05a3 3 0 0 0-3 3v2.51H2a.75.75 0 0 0 0 1.5h1.05v3.718H2a.75.75 0 0 0 0 1.5h1.05v3.718H2a.75.75 0 0 0 0 1.5h1.05Zm11.64-5.04-1.648-3.03-1.673 3.017-.056.077a2.42 2.42 0 0 0-.463 1.438c0 1.347 1.032 2.331 2.175 2.331 1.143 0 2.175-.984 2.175-2.331 0-.543-.172-1.035-.454-1.425l-.056-.077Zm-.765-4.546 2.037 3.745a3.92 3.92 0 0 1 .738 2.303c0 2.116-1.645 3.831-3.675 3.831S9.35 16.024 9.35 13.908c0-.874.28-1.68.754-2.325l2.068-3.73a1 1 0 0 1 1.753.007Z"
    />
  </svg>
);

export default ResultsSVG;
